var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartbeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4767_20544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 44C71 56.7025 60.7025 67 48 67C35.2975 67 25 56.7025 25 44C25 31.2975 35.2975 21 48 21C60.7025 21 71 31.2975 71 44ZM29.6 44C29.6 54.162 37.838 62.4 48 62.4C58.162 62.4 66.4 54.162 66.4 44C66.4 33.838 58.162 25.6 48 25.6C37.838 25.6 29.6 33.838 29.6 44Z",
    fill: "#FF6060"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 44,
    r: 19,
    fill: "#FF6060",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2857 46.4287H55.6897C55.6525 46.4734 55.6153 46.5124 55.5781 46.5459C55.5409 46.5794 55.5074 46.6073 55.4777 46.6296L55.4442 46.6742L48.4911 53.3707C48.3571 53.5046 48.1935 53.5716 48 53.5716C47.8065 53.5716 47.6429 53.5046 47.5089 53.3707L40.5446 46.6519C40.5074 46.637 40.4293 46.5626 40.3103 46.4287H44.4286C44.5923 46.4287 44.7392 46.3785 44.8694 46.278C44.9996 46.1776 45.0833 46.0492 45.1205 45.893L45.9018 42.7568L48.0223 50.201C48.067 50.3498 48.1525 50.4726 48.279 50.5693C48.4055 50.6661 48.5506 50.7144 48.7143 50.7144C48.8705 50.7144 49.0119 50.6661 49.1384 50.5693C49.2649 50.4726 49.3504 50.3498 49.3951 50.201L51.0246 44.7881L51.6496 46.0381C51.7835 46.2985 51.9955 46.4287 52.2857 46.4287ZM58 41.6519C58 42.7308 57.6168 43.8469 56.8504 45.0001H52.7321L51.4933 42.5336C51.4338 42.4071 51.3389 42.3067 51.2087 42.2323C51.0785 42.1579 50.9427 42.1281 50.8013 42.143C50.4665 42.1802 50.2582 42.3513 50.1763 42.6564L48.7366 47.4555L46.5491 39.7992C46.5045 39.6504 46.417 39.5277 46.2868 39.4309C46.1566 39.3342 46.0097 39.2859 45.846 39.2859C45.6823 39.2859 45.5372 39.3361 45.4107 39.4365C45.2842 39.537 45.2024 39.6653 45.1652 39.8216L43.8705 45.0001H39.1496C38.3832 43.8469 38 42.7308 38 41.6519C38 40.015 38.4725 38.7353 39.4174 37.8126C40.3624 36.89 41.6682 36.4287 43.3348 36.4287C43.7961 36.4287 44.2667 36.5087 44.7467 36.6687C45.2266 36.8286 45.673 37.0444 46.0859 37.316C46.4989 37.5876 46.8542 37.8424 47.1518 38.0805C47.4494 38.3186 47.7321 38.5716 48 38.8394C48.2679 38.5716 48.5506 38.3186 48.8482 38.0805C49.1458 37.8424 49.5011 37.5876 49.9141 37.316C50.327 37.0444 50.7734 36.8286 51.2533 36.6687C51.7333 36.5087 52.2039 36.4287 52.6652 36.4287C54.3318 36.4287 55.6376 36.89 56.5826 37.8126C57.5275 38.7353 58 40.015 58 41.6519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4767_20544",
    x: 0,
    y: 0.5,
    width: 95.5,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.92549 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4767_20544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4767_20544",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbeatIcon);
export default __webpack_public_path__ + "static/media/heartbeatIcon.5cb86e9e8d57b8c33fd96dde97abca04.svg";
export { ForwardRef as ReactComponent };